<script>
export default {
  methods: {
    continuePlaying() {
      this.$emit('continue');
    },
    exitGame() {
      this.$emit('exit');
    }
  }
}
</script>

<template>
  <div class="overlay d-flex justify-content-center align-items-center col-12">
    <div class="popup-card d-flex flex-column align-items-center col-10 position-relative">
      <img src="@/assets/gameplay/ExitPopUp/bg-block.png" class="bg-block" alt=""/>
      <div class="popup-content d-flex flex-column align-items-center col-12 position-absolute">
        <img src="@/assets/gameplay/ExitPopUp/cover-image.png" class="cover-image col-12" alt=""/>
        <div class="text-center text-white col-10 mt-3">
          <div class="title-text fw-bold">Your Progress is Saved!</div>
          <div class="body-text mt-2">You must complete this category before playing another. If you don't return, your game will reset tomorrow.</div>
        </div>
        <img src="@/assets/gameplay/ExitPopUp/continue-playing-button.png" class="col-10 mt-4" alt="Continue Playing" @click="continuePlaying"/>
        <img src="@/assets/gameplay/ExitPopUp/exit-game-button.png" class="col-10 mt-3" alt="Exit Game" @click="exitGame"/>
      </div>
    </div>
  </div>
</template>

<style scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 200;
}

.popup-card {
  max-width: 400px;
}

.bg-block {
  width: 100%;
  border-radius: 16px;
}

.popup-content {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.cover-image {
  border-radius: 16px 16px 0 0;
}

.title-text {
  font-size: 20px;
  color: #D8D8D8;
}

.body-text {
  font-size: 14px;
  color: #D8D8D8;
}
</style>
